<template>
  <form id="id-close-convo-form">
    <div class="form-group">
      <div class="row">
        <label for="new-convo-initial-msg" style="float: left;">
          Closing Message
        </label>
      </div>
      <div class="pt-1">
        <textarea
          v-model="message"
          style="resize:none;"
          class="form-control"
          rows="3"
        ></textarea>
      </div>

      <b-form-invalid-feedback :state="!!error ? false : true">
        {{ error }}
      </b-form-invalid-feedback>
    </div>
    <div class="modal-footer bg-light stretch-footer d-flex align-items-center justify-content-between gap-3">
      <div class="form-check form-switch">
        <input
          class="form-check-input"
          type="checkbox"
          role="switch"
          :checked="sendTerminationMesage"
          @change="() => { sendTerminationMesage = !sendTerminationMesage }"
        />
        <label class="form-check-label">
          Send Termination Message
        </label>
      </div>
      <b-button
        type="button"
        variant="danger"
        pill
        @click="validateForm"
        :disabled="httpPending"
      >
        <i v-if="httpPending" class="fa fa-spinner fa-spin"></i>
        <template v-else>Close Conversation</template>
      </b-button>
    </div>
  </form>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import { EventBus } from '@/events/eventBus';

export default {
  name: "CloseConversation",
  data() {
    return {
      message: '',
      httpPending: false,
      sendTerminationMesage: false,
      error: '',
    };
  },
  computed: {
    ...mapGetters("agency", ["agencySettings"]),
    ...mapGetters("conversations", ["currentConversation"]),
  },
  created() {
    this.message = this.agencySettings.closedConversationMessage || '';
    this.sendTerminationMesage = this.currentConversation.channel === 'sms';
  },
  methods: {
    async validateForm() {
      let resp = null;
      try {
        this.httpPending = true;
        this.error = '';
        const message = this.message.trim();
        if (!message && this.sendTerminationMesage) {
          this.error = "Closing message is required.";
        }

        if (this.error) {
          this.httpPending = false;
          return;
        }

        const conversationId = this.$route.params.conversationId;
        const payload = this.sendTerminationMesage ? { message_body: message } : {};
        resp = await this.$ConveyApi.conversationsApi.closeConversation({
          conversationId,
          payload,
        });
        this.$toastr("success", "Conversation Closed");
      } catch(err) {
        console.log("[CloseConversation] ERROR: ", err);
        this.$toastr("error", 'Error Closing Conversation. Please try again.');
      } finally {
        this.httpPending = false;
        if (resp && resp.status == 200) {
          this.$store.commit("conversations/closeConversation", this.conversationId);
          setTimeout(() => {
            EventBus.$emit('close-modal');
            this.$router.push({ name: "Conversations Dashboard" }).catch(() => {});
          }, 500);
        }
      }
    }
  },
};
</script>

<style scoped>
.stretch-footer {
  margin-left: -16px;
  margin-right: -16px;
  margin-bottom: -16px;
}
</style>